require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _RadioButtonGroup = _interopRequireDefault(require("./RadioButtonGroup"));

var _RadioButtonAndroid = _interopRequireDefault(require("./RadioButtonAndroid"));

var _RadioButtonIOS = _interopRequireDefault(require("./RadioButtonIOS"));

var _RadioButtonItem = _interopRequireDefault(require("./RadioButtonItem"));

var _theming = require("../../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/RadioButton/RadioButton.tsx";

var RadioButton = function (_React$Component) {
  (0, _inherits2["default"])(RadioButton, _React$Component);

  function RadioButton() {
    (0, _classCallCheck2["default"])(this, RadioButton);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RadioButton).apply(this, arguments));
  }

  (0, _createClass2["default"])(RadioButton, [{
    key: "render",
    value: function render() {
      var Button = _reactNative.Platform.select({
        "default": _RadioButtonAndroid["default"],
        ios: _RadioButtonIOS["default"]
      });

      return React.createElement(Button, (0, _extends2["default"])({}, this.props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114
        }
      }));
    }
  }]);
  return RadioButton;
}(React.Component);

(0, _defineProperty2["default"])(RadioButton, "Group", _RadioButtonGroup["default"]);
(0, _defineProperty2["default"])(RadioButton, "Android", _RadioButtonAndroid["default"]);
(0, _defineProperty2["default"])(RadioButton, "IOS", _RadioButtonIOS["default"]);
(0, _defineProperty2["default"])(RadioButton, "Item", _RadioButtonItem["default"]);

var _default = (0, _theming.withTheme)(RadioButton);

exports["default"] = _default;